import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { CommonHelper } from '../../../../utilities/common.helper';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ChangeRoleService } from './service/change-role.service';
import { SharedService } from '../../../../shared/sharedServices/shared.service';

@Component({
  selector: 'kt-change-of-role',
  templateUrl: './change-of-role.component.html',
  styleUrls: ['./change-of-role.component.scss'],
  providers:[ChangeRoleService]
})
export class ChangeOfRoleComponent implements OnInit {
  
  public isDataPresent: boolean = true
  public form: FormGroup;
  public dropdownCategories:any = null
  public pageState:string = null

  constructor(private dialogRef: MatDialogRef<ChangeOfRoleComponent>,
              private changeRoleService:ChangeRoleService,
              private sharedService: SharedService,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any,   
              private formBuilder: FormBuilder) { }


  ngOnInit() {
    this.form = this.formBuilder.group({
      categoryName: new FormControl(null, Validators.required),
    })
    this.pageState = this.data.pageState
    this.getCategoryList(this.data.panelData.panelId ? this.data.panelData.panelId : 0)
  }

  public onButtonClick(button?) {
    this.dialogRef.close(button);
  }

  private getCategoryList(panelId) {
    let panelMemberId = this.data.newRow.rgaPanelMemberId ? this.data.newRow.rgaPanelMemberId : 0
    this.sharedService.getCategoryListForTeamManagement(panelId,panelMemberId).subscribe(
      (response: any) => {
        if (response && response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.dropdownCategories = response['data']
        }
        else {
          this.dropdownCategories = []
          this.sharedService.showError(response.statusDescription, 'OK', 'error-snackbar');
        }
      },
      (err) => {
        this.dropdownCategories = []
        this.sharedService.showError(err.error, 'OK', 'error-snackbar');
      })
  }

  private markFormsTouched(): void {
    CommonHelper.markFormGroupTouched(this.form);
  }

  private formValid(payload): boolean {
    return this.form.valid && payload.rgaRoleViewDtoList.length > 0
  }

  private constructPayload() {
    let payload = {
        panelId:this.data.panelData.panelId ? this.data.panelData.panelId : null,
        panelName:this.data.panelData.panelName ? this.data.panelData.panelName : null,
        rgaRoleViewDtoList: [this.data.newRow]
    }
    payload.rgaRoleViewDtoList[0].categoryName = this.form.value.categoryName
    return payload;
  }

  private constructPayloadTypeTwo() {
    let payload = {
        rgaRoleViewDtoList: [this.data.newRow]
    }
    payload.rgaRoleViewDtoList[0].categoryName = this.form.value.categoryName
    return payload;
  }

  public updateRole():void{
    if(this.pageState == 'JMP' || this.pageState == 'Steering Committee' || this.pageState == 'HLEP'){
      this.updateRoleTypeTwo()
    }
    else{
      this.updateRoleOthers()
    }
  }

  private updateRoleTypeTwo(): void {
    this.markFormsTouched();
    let payload = this.constructPayloadTypeTwo()
    if (!this.formValid(payload))
      return;
    this.isDataPresent = false
    if (payload && payload.rgaRoleViewDtoList) {
      if (payload.rgaRoleViewDtoList[0].isInvited && payload.rgaRoleViewDtoList[0].isInvited == true) {
        this.isInvitationNotAcceptedTypeTwo(payload)
      }
      else {
        this.isInvitationAcceptedTypeTwo(payload)
      }
    }
    else {
      this.isDataPresent = true
    }
  }

  private isInvitationAcceptedTypeTwo(payload):void{
    this.changeRoleService.notInvitedChangeOfRole(payload,this.pageState)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {    
          this.dialogRef.close({ payload })
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
        else {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } 
        else {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        }
      }
    )

  }

  private isInvitationNotAcceptedTypeTwo(payload):void{
    this.changeRoleService.invitedChangeOfRole(payload,this.pageState)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
     
          this.dialogRef.close({ payload })
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
        else {
           this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } 
        else {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        }
      }
    )

  }

  private updateRoleOthers(): void {
    this.markFormsTouched();
    let payload = this.constructPayload()
    if (!this.formValid(payload))
      return;
    this.isDataPresent = false
    if (payload && payload.rgaRoleViewDtoList) {
      if (payload.rgaRoleViewDtoList[0].isInvited && payload.rgaRoleViewDtoList[0].isInvited == true) {
        this.isInvitationNotAccepted(payload)
      }
      else {
        this.isInvitationAccepted(payload)
      }
    }
    else {
      this.isDataPresent = true
    }

  }

  private isInvitationAccepted(payload):void{
    this.changeRoleService.notInvitedMemberChangeOfRole(payload)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
       
          this.dialogRef.close({ payload })
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
        else {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } 
        else {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        }
      }
    )

  }

  private isInvitationNotAccepted(payload):void{
    this.changeRoleService.invitedMemberChangeOfRole(payload)
    .subscribe(
      (res: any) => {
        this.isDataPresent = true
        if (+res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
         
          this.dialogRef.close({ payload })
          this.sharedService.showError(res.statusDescription, 'OK', 'success-snackbar');
        }
        else {
          this.sharedService.showError(res.statusDescription, 'OK', 'error-snackbar');
        }
      },
      (err) => {
        this.isDataPresent = true
        if (+err.error.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNAUTHORIZED) {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        } 
        else {
          this.sharedService.showError(+err.error.statusDescription, 'OK', 'error-snackbar');
        }
      }
    )

  }


}
